"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveTravelAgentsOptions = void 0;
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
let RetrieveTravelAgentsOptions = class RetrieveTravelAgentsOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
};
exports.RetrieveTravelAgentsOptions = RetrieveTravelAgentsOptions;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => String(item)))),
    __metadata("design:type", Array)
], RetrieveTravelAgentsOptions.prototype, "ids", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveTravelAgentsOptions.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => Number(item)))),
    __metadata("design:type", Array)
], RetrieveTravelAgentsOptions.prototype, "statusIn", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => String(item)))),
    __metadata("design:type", Array)
], RetrieveTravelAgentsOptions.prototype, "ownerIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => String(item)))),
    __metadata("design:type", Array)
], RetrieveTravelAgentsOptions.prototype, "agentIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        if ((0, utils_1.isUndefinedOrNull)(value)) {
            return undefined;
        }
        if (!Array.isArray(value)) {
            value = [value];
        }
        return value.map((item) => String(item));
    }),
    __metadata("design:type", Array)
], RetrieveTravelAgentsOptions.prototype, "hostAgencyIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveTravelAgentsOptions.prototype, "hasPendingScheduledEmails", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveTravelAgentsOptions.prototype, "isApproved", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveTravelAgentsOptions.prototype, "countryIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveTravelAgentsOptions.prototype, "includeTravelAgentsWithoutCountry", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        if (value === "true") {
            return true;
        }
        if (value === "false") {
            return false;
        }
        return value;
    }),
    __metadata("design:type", Boolean)
], RetrieveTravelAgentsOptions.prototype, "partnerBookingAvailable", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveTravelAgentsOptions.prototype, "travelAgentCategory", void 0);
exports.RetrieveTravelAgentsOptions = RetrieveTravelAgentsOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveTravelAgentsOptions);
//# sourceMappingURL=RetrieveTravelAgentsOptions.js.map